// Navigation Toggles

class Navigation {
  constructor() {
    this.navItems = [].slice.call(
      document.querySelectorAll('.header__list-item__trigger')
    );

    this.navToggles = [].slice.call(
      document.querySelectorAll('.header__menu-toggle')
    );

    this.listToggles = [].slice.call(
      document.querySelectorAll('.header__list-item__sub-menu__trigger')
    );

    this.navItems.forEach(navItem => {
      const body = document.querySelector('.main-content');
      const dropdowns = document.querySelectorAll('.header__list-item');

      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {

        body.addEventListener(event, e => {

          [].forEach.call(dropdowns, function(dropdown) {
            dropdown.classList.remove('open');
          });
        })

        navItem.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            const parent = navItem.parentNode;
            parent.classList.toggle('open');

            if (!e.target.parentElement.classList.contains('open')) {
              e.target.classList.add(parent.dataset.cc);
            } else {
              e.target.classList.remove(parent.dataset.cc);
            }
          }
        });
      });
    });

    this.navToggles.forEach(navToggle => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        navToggle.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            const menu = document.querySelector('.header__list-wrap');

            menu.classList.toggle('active');
            navToggle.classList.toggle('active');
          }
        });
      });
    });

    this.listToggles.forEach(navItem => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        navItem.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            const grandparent = navItem.parentNode.parentNode;
            grandparent.classList.toggle('open');
          }
        });
      });
    });
  }
}

const navInit = {
  init() {
    // if element exists init this class
    const wrapperEl = document.getElementById('navigation');
    if (wrapperEl !== null) {
      // eslint-disable-next-line no-unused-vars
      const navigationWrap = new Navigation(wrapperEl);
    }
  },
};

export default navInit;
